interface AlgoliaHits {
  variants: Record<string, unknown>[]
  variant_attributes: Record<string, unknown>[][]
}

export const isMultiVariantProduct = (
  product: AlgoliaHits,
  isMVExperimentEnabled: boolean
) => {
  const { variants = [], variant_attributes = [] } = product
  return (
    isMVExperimentEnabled &&
    variant_attributes.length > 1 &&
    variants.length > 1
  )
}

export const findCheapestPriceFromMVProduct = (
  product: AlgoliaHits
): number | undefined => {
  const prices = product.variants
    .map(v => v.retailPrice)
    .filter((v): v is number => typeof v === 'number')
  return prices.length > 0 ? Math.min(...prices) : undefined
}
